exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".grecaptcha-badge {\n  visibility: hidden;\n}", ""]);

